// 8.3.8 Interview Practice UI (merged as `iv`).
const iv = {
 "scriptLatin": "Latin",
 "scriptCyrillic": "Cyrillic",
 "tabNew": "New chat",
 "tabChats": "Chats",
 "tabInterview": "Interview",
 "cardTitle": "Interview Practice",
 "cardSub": "Practice an important conversation before it happens.",
 "promise": "Practice the conversations that matter before they happen.",
 "support": "Choose an interview or describe your own. Your interviewer adapts to your level and answers.",
 "fam": {
  "work": "Work",
  "education": "Education",
  "travel": "Travel & official",
  "public": "Professional",
  "personal": "Personal",
  "custom": "Custom"
 },
 "sc": {
  "job": "Job interview",
  "internship": "Internship interview",
  "promotion": "Promotion interview",
  "freelance": "Freelance client intro",
  "networking": "Networking",
  "university": "University admission",
  "scholarship": "Scholarship interview",
  "oral_exam": "School oral exam",
  "language_exam": "Language oral exam",
  "visa": "Visa-style interview",
  "travel_questions": "Travel questioning",
  "hotel_problem": "Hotel/travel problem",
  "media": "Media/podcast interview",
  "presentation_qa": "Presentation Q&A",
  "client_meeting": "Client meeting",
  "pro_intro": "Professional introduction",
  "housing": "Apartment/housing",
  "doctor": "Doctor appointment",
  "meet_new": "Meeting someone new",
  "difficult": "Difficult conversation",
  "custom": "Describe your own"
 },
 "contextLabel": "What should the interviewer know?",
 "contextPh": "Optional: role, company, subject, what worries you…",
 "customPh": "Describe your interview, e.g. “Tomorrow I have a hotel receptionist interview in Madrid.”",
 "length": "Length",
 "quick": "Quick — about 5 questions",
 "standard": "Standard — about 10 questions",
 "deep": "Deep — about 15 questions",
 "style": "Practice style",
 "supportive": "Supportive",
 "realistic": "Realistic",
 "challenging": "Challenging",
 "start": "Start interview",
 "starting": "Preparing your interviewer…",
 "progress": "{n} of {total}",
 "answerPh": "Your answer…",
 "send": "Send",
 "type": "Type",
 "speak": "Speak",
 "listen": "Listen",
 "help": "Help me say this",
 "helpPh": "Write what you want to say, in any language",
 "helpGo": "Show me",
 "helpNote": "Use it as a model — then write your own answer.",
 "finished": "Thanks — that concludes the interview. Let's look at how you did.",
 "seeReport": "See my feedback",
 "building": "Preparing your feedback…",
 "overall": "Overall",
 "areasT": "Coaching areas",
 "areas": {
  "clarity": "Clarity",
  "vocabulary": "Vocabulary",
  "grammar": "Grammar",
  "naturalness": "Naturalness",
  "effectiveness": "Interview effectiveness"
 },
 "lv": {
  "strong": "Strong",
  "developing": "Developing",
  "needs_practice": "Needs practice"
 },
 "worked": "What worked",
 "improve": "Improve next",
 "better": "Better ways to say it",
 "phrases": "Useful phrases",
 "save": "Save",
 "saved": "Saved to Vocab",
 "history": "Your interviews",
 "empty": "No interviews yet.",
 "resume": "Resume",
 "startOver": "Start over",
 "view": "View",
 "st": {
  "active": "In progress",
  "answered": "Ready for feedback",
  "completed": "Completed"
 },
 "retry": "Something went wrong. Your answers are safe — try again.",
 "retryBtn": "Try again",
 "newInterview": "New interview",
 "back": "Back",
 "suggest": "Have an important conversation coming up?",
 "suggestBtn": "Try Interview Practice",
 "dismiss": "Dismiss",
 "recording": "Recording… tap to stop",
 "transcribing": "Transcribing…",
 "micFail": "Voice isn't working — type your answer instead.",
 "disclaimer": "Language practice only — not legal, immigration, medical or hiring advice.",
 "describeFirst": "Describe your interview first."
};
export default iv;
